import React, { useEffect, useState } from "react";
import "./event.css";
import Footer from "../Footer/Footer";
import EventHeader from "./EventHeader";
import EventNav from "./EventNav";
import { useNavigate } from "react-router-dom";

const Event: React.FC = () => {
  const [activePopup, setActivePopup] = useState<number | null>(null);
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const handleGetInTouch = () => {
    if (window.location.pathname === "/") {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const contactSection = document.getElementById("contact");
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  useEffect(() => {
    const faders = document.querySelectorAll(".fade-in");

    const appearOptions = {
      threshold: 0.2,
      rootMargin: "0px 0px -200px 0px",
    };

    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("show");
        observer.unobserve(entry.target);
      });
    }, appearOptions);

    faders.forEach((fader, index) => {
      const el = fader as HTMLElement;
      el.style.transitionDelay = `${index * 0.03}s`;
      appearOnScroll.observe(el);
    });
  }, []);

  // 🔹 Workshop adatok (ISO dátum formátummal)
  const workshops = [
    {
      id: 1,
      img: "workshop.png",
      short: "6 March 2026 – 9am to 4.30pm via Zoom (6.5 CPD hours)",
      title:
        "Workshop One: Risk Assessment and Identification of Gender-Based Violence",
      full: `The Risk Assessment and Identification of Gender-Based Violence training 
      provides participants with a clear understanding of the core principles behind assessing and managing risk in cases of gender-based violence. 
      Participants will learn how to interpret and apply assessment outcomes to ensure safety, guide decision-making, and inform effective and evidence-based interventions.
      
      Presented by Dr. Chelsey Dewson, forensic psychologist with 20+ years of expertise.
      
      Date: 15 March 2026
      Time: 10am – 4pm
      Format: Online
      CPD: 6 hours`,
      date: "2026-03-15",
    },
    {
      id: 2,
      img: "workshop2.png",
      title:
        "Workshop Two: Responding Therapeutically to the Risks Associated with Gender-Based Violence",
      short: "3 April 2026 – 9am to 4.30pm – via Zoom (6.5 CPD hours)",
      full: `This workshop will focus on challenges clinicians face when working with clients 
      in relation to gender-based violence (defensiveness, resistance, therapy-interfering behaviours). 
      It will cover strategies for therapeutic engagement, supervision, and personal safety.
      
      Presented by Dr. Katie Seidler, clinical and forensic psychologist with 30 years of expertise.
      
      Date: 3 April 2026
      Time: 9am – 4:30pm
      Format: Zoom
      CPD: 6.5 hours`,
      date: "2026-04-03",
    },
  ];

  // 🔹 Csak a jövőbeli workshopok megjelenítése
  const today = new Date();
  const upcomingWorkshops = workshops.filter(
    (w) => new Date(w.date) >= today
  );

  return (
    <>
      <EventNav />
      <EventHeader />
      <div className="event-container">
        {/* Bemutató szöveg */}
        <div className="event-intro">
          <h2 className="event-h2 fade-in">Upcoming Workshops</h2>
          <p className="fade-in">
            Understanding the risk and threat associated with human behaviour is
            a unique, dynamic and developing area of professional practice in
            which TAG has leading expertise. TAG strives to promote safety and
            security through human risk identification, assessment, mitigation
            and management. In early 2026, TAG will be offering two online
            professional development workshops aimed at mental health clinicians
            (psychologists, counsellors, clinical case workers etc) working in
            educational settings in better understanding and responding to
            gender based violence.
          </p>
        </div>

        {/* Workshop kártyák */}
        <div className="event-grid fade-in">
          {upcomingWorkshops.length > 0 ? (
            upcomingWorkshops.map((workshop) => (
              <div
                key={workshop.id}
                className="event-card fade-in"
                onClick={() => setActivePopup(workshop.id)}
              >
                <img
                  src={workshop.img}
                  alt={workshop.title}
                  className="event-img"
                />
                <h3>{workshop.title}</h3>
                <p>{workshop.short}</p>
              </div>
            ))
          ) : (
            <p className="fade-in no-workshops">
              No upcoming workshops at the moment.
            </p>
          )}
        </div>

        {/* Árlista */}
        {upcomingWorkshops.length > 0 && (
          <div className="event-fees fade-in">
            <h3>Fees:</h3>
            <p>One workshop – $250 + GST</p>
            <p>Two workshops – $400 + GST</p>
          </div>
        )}

        {/* Kapcsolat */}
        <div className="footer-question">
          <h2 className="question fade-in">Need more information?</h2>
          <h2 className="text fade-in">
            For further information or to register, contact:
            <br />
            <a href="mailto:admin@threatadvisorygroup.com" className="email">
              admin@threatadvisorygroup.com
            </a>
          </h2>
        </div>

        {/* Popup ablak */}
        {activePopup !== null && (
          <div className="popup-overlay">
            <div className="popup">
              <button
                className="popup-close"
                onClick={() => setActivePopup(null)}
              >
                ×
              </button>
              <h3>
                {upcomingWorkshops.find((w) => w.id === activePopup)?.title}
              </h3>
              <p>
                {upcomingWorkshops.find((w) => w.id === activePopup)?.full}
              </p>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Event;
